module.exports = __webpack_public_path__ + "static/media/locais.07e404dd.png";